module.exports = __webpack_public_path__ + "media/images/icon__arrow-left@3x-e9cd979cbc5cc0b99f4fbb4922de9729.png";